<template>
  <v-toolbar
    flat
    class="transparent"
  >
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-avatar
            color="grey lighten-1"
            size="48px"
          >
            <v-icon dark>
              account_circle
            </v-icon>
          </v-avatar>
        </v-list-tile-avatar>
        <!-- end avatar -->

        <v-list-tile-content>
          <v-list-tile-title v-text="user.name" />
          <v-list-tile-sub-title v-text="user.email" />
        </v-list-tile-content>
        <!-- end content -->

        <v-list-tile-action>
          <v-btn
            icon
            @click.stop="onSignOut"
          >
            <v-icon color="error">
              exit_to_app
            </v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data: () => ({
    displayOption: false
  }),
  computed: {
    ...mapGetters({
      user: 'auth/currentUser'
    })
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout'
    }),
    onSignOut () {
      this.logout().then(() => this.$router.go({ name: 'auth.login' }))
    }
  }
}
</script>
